import { useCarbucksApi } from './Api/CarbucksApi';
import { type ICarbucksViewModel, useViewModelInstance as useCarbucksViewModelInstance} from "@app/Carbucks";
import { useConfirm, ModalButtons } from "@library/Components/Modal/ModalTypes";
import { ref } from 'vue';
import { useRouter } from "@library/Services";
import { currency } from '@library/Utilities';

export async function useRedeemCashbackViewModel()
{
    const viewModel = new RedeemCashbackViewModel();
    await viewModel.initialise();
    return viewModel;
}

export class RedeemCashbackViewModel
{
    carbucks!: ICarbucksViewModel;
    payoutAmount = ref( 10 );
    errorState = ref<string | null>( null );
    buttonState = ref<'lowest' | 'middle' | 'highest' | 'custom'>( 'lowest' );

    quickSetButtons = {
        'lowest': 10,
        'middle': 0,
        'highest': 0
    };

    validation = {
        
    };

    async initialise()
    {
        this.carbucks = await useCarbucksViewModelInstance();
        
        const multiplier = 10;
        const highest10 = Math.floor( this.carbucks.profile.availableAmount / multiplier ) * multiplier;
        this.quickSetButtons.highest = highest10;
        this.quickSetButtons.middle = highest10 / 2;
    }

    /**
     * Sends the payout amount entered/selected to the API to request a payout from the marketplace partner.
     */
    async performPayout()
    {
        this.errorState.value = null;
        const payout = Number( this.payoutAmount.value );
    
        // Perform some client side validation on the number entered. This same check is completed in the server.
        if ( isNaN( payout ) || payout <= 0 )
        {
            this.errorState.value = 'Please enter in a valid amount greater than 0';
    
            return;
        }
    
        // Perform some client side validation to ensure that the user can redeem the amount requested. This same check is completed on the server.
        if ( !this.carbucks.profile.canRedeemCashbackAmount( payout ) )
        {
            this.errorState.value = `The payout amount cannot exceed ${currency( this.carbucks.profile.availableAmount )}`;
    
            return;
        }
        
        const api = useCarbucksApi();
    
        const response = await api.redeemCashback( payout );
    
        if ( response.success )
        {
            /**
             * If the request succeeded, we need to update the available amount in the profile with the new balance.
             * This will also ensure we do not need to re-retrieve the entire profile just for the one number that is
             * being updated.
             */
            this.carbucks.profile.updateAvailableAmount( response.newBalance );

            await useConfirm( 'Thank you, the transfer request has been issued.<br/>Please note that it can take 2-3 working days before the funds will appear in your account.<br/>We appreciate your patience.', '', [
                ModalButtons.Primary( 'Back to Profile', true )
            ] );
    
            const router = useRouter();
    
            router.back();
    
            return;
        }
    
        this.errorState.value = response.errorMessage;
    }
    
    /**
     * Updates the payout amount member with a specific value.
     */
    updatePayoutAmount( amount: number )
    {
        this.payoutAmount.value = amount;
    }
    
}